import { render, staticRenderFns } from "./reviewWorkflowUserGroup.vue?vue&type=template&id=68ded349&scoped=true"
import script from "./reviewWorkflowUserGroup.vue?vue&type=script&lang=js"
export * from "./reviewWorkflowUserGroup.vue?vue&type=script&lang=js"
import style0 from "./reviewWorkflowUserGroup.vue?vue&type=style&index=0&id=68ded349&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ded349",
  null
  
)

export default component.exports